import React, { Component } from 'react';
import LeftRight from '../leftright/LeftRight';
import TitleContainer from '../title-container/TitleContainer';

class AlignmentContainer extends Component {
  
  constructor(props) {
      super(props);
    }

  render() {
    if(this.props.alignment === 'center') {
        return(
            <TitleContainer
              title={this.props.title}
              titleHeight={this.props.titleHeight}
              text={this.props.text}
              fluid={true}
              theme={this.props.theme}
              cta={this.props.cta}
              countdownTimer={this.props.countdownTimer}
              useH1={this.props.useH1}
            />
        );
    } else  {
      return (
            <LeftRight
              title={this.props.title}
              text={this.props.text}
              fluid={true}
              theme={this.props.theme}
              cta={this.props.cta}
              imageAlignment={this.props.alignment === 'right' ? 'left' : 'right'}
              countdownTimer={this.props.countdownTimer}
              useH1={this.props.useH1}
            />
      );
    }
  }
}

export default AlignmentContainer;